import $ from 'jquery';

let $menuIcons;
let $mobileMenu;
let $showMobileMenu;

function showMobileMenu(event) {
    event.preventDefault();
    $(this).toggleClass("rotate-icon"); // .next().slideToggle();
    $menuIcons.toggle();
    $mobileMenu.slideToggle();
}
export function handleMobileMenu(showMobileMenuSelector, mobileMenuSelector) {
    $mobileMenu = $(mobileMenuSelector);
    $showMobileMenu = $(showMobileMenuSelector);
    $menuIcons = $showMobileMenu.find("span");
    $showMobileMenu.on("click", showMobileMenu);
}